<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog v-dialog-drag width="70%" :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length > 0 ? 'dialog-scroller' : '']" style="display: flex;flex-direction: column;">
        <div style="padding-bottom: 10px;">
          <el-button :loading="downLoading" size="mini" icon="el-icon-document-add" type="primary" @click="exportOrder">
            {{ $t('xiazaimuban') }}
          </el-button>
        </div>

        <!-- 导出工单条件 -->
        <el-form size="mini" :inline="true" :model="conditions" class="demo-form-inline">
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="conditions.noInMainAndChild"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao(jingzhun)')">
            <el-input v-model="conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="conditions.materialIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="conditions.orgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="conditions.status">
              <el-option :label="$t('daipaichan')" :value="1"></el-option>
              <el-option :label="$t('yipaichan')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jihuakaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="conditions.planStartTimeStart" :end.sync="conditions.planStartTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('jihuawanchengshijian')">
            <yi_time_input type="datetimerange" :start.sync="conditions.planEndTimeStart" :end.sync="conditions.planEndTimeEnd"> </yi_time_input>
          </el-form-item>
        </el-form>

        <div>
          <el-button :disabled="downLoading" :loading="uploadLoading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{ $t('piliangshangchuan') }}
          </el-button>
          <el-button :loading="exportLoading" size="mini" type="default" icon="el-icon-document-add" @click="exportReport">
            {{ $t('daochubaogao') }}
          </el-button>
        </div>
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple accept=".xlsx, .xls" @change="handleClick" />
        </div>
        <!--excel-->
        <div>
          <span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
            <i class="el-icon-link" />
            <span>{{ item }}</span>
            <i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)" />
          </span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
          <el-table stripe :max-height="tableHeight" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" border size="mini" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :show-overflow-tooltip="true" :label="item.label" :width="item.width" :sortable="item.sortable">
              <template slot-scope="scope">
                <span>{{ scope.row[item.prop] === '' ? '-' : scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="visible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" :loading="saveLoading" @click="importData">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveLoading: false,
      downLoading: false,
      exportLoading: false,
      uploadLoading: false,
      conditions: {
        pageNum: 1,
        pageSize: 99999,
        orderBy: 'createTime desc'
      },
      excel: [],
      tableHeight: 0,
      tableData: [],
      tableColumn: [
        {
          label: this.$t('daorubaogao'),
          prop: 'result',
          width: 125
        },
        {
          label: this.$t('jihuadanhao'),
          prop: 'no',
          width: 150
        },
        {
          label: this.$t('ERPgongdanhao'),
          prop: 'erpNo',
          width: 150
        },
        {
          label: this.$t('shebeimingcheng'),
          prop: 'equipmentName',
          width: 150
        },
        {
          label: this.$t('mujubianhao'),
          prop: 'mouldNo',
          width: 150
        },
        {
          label: this.$t('mujubianma'),
          prop: 'mouldCode',
          width: 150
        },
        {
          label: this.$t('mojumingcheng'),
          prop: 'mouldName',
          width: 150
        },
        {
          label: this.$t('moqiangshu'),
          prop: 'cavity',
          width: 150
        },
        {
          label: this.$t('biaozhunzhouqi(miao/mo)'),
          prop: 'standardCycle',
          width: 150
        },
        {
          label: this.$t('chanpinbianma'),
          prop: 'materialCode',
          width: 150
        },
        {
          label: this.$t('chanpinmingcheng'),
          prop: 'materialName',
          width: 150
        },
        {
          label: this.$t('caizhi'),
          prop: 'ingredient',
          width: 150
        },
        {
          label: this.$t('bencipaichanshuliang'),
          prop: 'quantity',
          width: 150
        },
        {
          label: this.$t('jihuakaishishijian'),
          prop: 'startTime',
          width: 150
        },
        {
          label: this.$t('jihuawanchengshijian'),
          prop: 'endTime',
          width: 150
        },
        {
          label: this.$t('guishuchejian'),
          prop: 'orgCode',
          width: 150
        },
        {
          label: this.$t('guishuzhujihuadanhao'),
          prop: 'mainPlanNo',
          width: 150
        },
        {
          label: this.$t('gongdanshunxu'),
          prop: 'priority',
          width: 150
        },
        {
          label: this.$t('shifoujiaji'),
          prop: 'urgent',
          width: 150
        },
        {
          label: this.$t('guidingchanneng'),
          prop: 'regularCapacity',
        },
        {
          label: this.$t('beizhu'),
          prop: 'remark'
        }
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('piliangdaorupaichanfafang')
    };
  },
  watch: {
    show: {
      handler(n) {
        this.visible = n;
        if (n == true) {
          this.countTableHeight();
        }
        if (n == false) {
          this.currentPage = 1;
        }
      },
      immediate: false
    },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:show', false);
          this.tableData = [];
          this.excel = [];
          this.conditions.equipmentIdList = [];
          this.$refs['excel-upload-input'].value = null;
        }
      },
      immediate: false
    }
  },
  created() { },
  methods: {
    // 导出报告
    exportReport() {
      const data = this.deepClone([...this.tableData]);
      if (data.length === 0) {
        return this.$message.warning(this.$t('qingshangchuanwenjian'));
      }
      this.exportLoading = true;
      this.exportReportExcel(data);
      this.exportLoading = false;
    },

    // 导出报告的Excel
    exportReportExcel(data) {
      // 筛选出表头和prop
      let tableFirst = this.tableColumn.map(column => column.label);
      let tableProp = this.tableColumn.map(column => column.prop);
      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < data.length; i++) {
        let dataArr = [];
        for (let j = 0; j < tableProp.length; j++) {
          dataArr.push(data[i][tableProp[j]]);
        }
        tableArr.push(dataArr);
      }
      console.log('tableArr', tableArr);
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `生产计划_批量导入排产发放_导入报告_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },

    // 导出计划单
    exportOrder() {
      this.downLoading = true;
      this.http
        .get('/web/production/plan/page', { params: this.conditions })
        .then(async res => {
          if (res.data && res.data.total > 0 && res.data.rows.length > 0) {
            let rows = res.data.rows;
            // 收集产品编码
            let materialCodes = [];
            for (let i = 0; i < rows.length; i++) {
              const row = rows[i];
              const code = row.material && row.material.code;
              if (code) {
                materialCodes.push(code);
              }
              const childrens = row.children;
              if (childrens && childrens.length > 0) {
                for (let j = 0; j < childrens.length; j++) {
                  const childRow = childrens[j];
                  const childCode = childRow.material && childRow.material.code;
                  if (childCode) {
                    materialCodes.push(childCode);
                  }
                }
              }
            }

            // 根据产品编码查询最早创建的机模配信息
            let codeMap = {};
            if (materialCodes.length > 0) {
              const { data: res } = await this.http.post('/web/basic/mouldEquipment/getByMaterialCodes', materialCodes);
              codeMap = res;
            }
            this.exportDownloadExcel(rows, codeMap);
          } else {
            this.$message.warning(this.$t('meiyoufuhetiaojiandejihuadan'));
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.downLoading = false;
        });
    },
    // 导出下载模板的Excel
    exportDownloadExcel(rows, codeMap) {
      // 筛选出表头和prop
      let tableFirst = [];
      let tableProp = [];
      for (let i = 0; i < this.tableColumn.length; i++) {
        const column = this.tableColumn[i];
        // 过滤掉导入报告的表头
        if (column.prop === 'result') {
          continue;
        }
        tableFirst.push(column.label);
        tableProp.push(column.prop);
      }

      // 顺序封装表格数据
      let tableArr = [];
      tableArr.push(tableFirst);
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        // 主单
        let dataArr = this.getTableDataArr(row, '', codeMap);
        tableArr.push(dataArr);
        // 子单
        const childrens = row.children;
        if (childrens && childrens.length > 0) {
          for (let j = 0; j < childrens.length; j++) {
            const childRow = childrens[j];
            let dataArr = this.getTableDataArr(childRow, row.no, codeMap);
            tableArr.push(dataArr);
          }
        }
      }
      const worksheet = XLSX.utils.aoa_to_sheet(tableArr);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      XLSX.writeFile(workbook, `生产计划_导入排产发放模板_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
    },
    // 封装Excel表格行数据
    getTableDataArr(row, mainPlanNo, codeMap) {
      const code = row.material && row.material.code;
      const info = codeMap[code];
      if (info) {
        row.equipment = info.equipment;
        row.mould = info.mould;
        row.cavity = info.actualCavity;
        row.standardCycle = info.cycle;
      }

      let dataArr = [];
      let i = 0;
      dataArr[i++] = row.no;
      dataArr[i++] = row.erpNo;
      dataArr[i++] = row.equipment && row.equipment.name;
      dataArr[i++] = row.mould && row.mould.no;
      dataArr[i++] = row.mould && row.mould.code;
      dataArr[i++] = row.mould && row.mould.name;
      dataArr[i++] = row.cavity;
      dataArr[i++] = row.standardCycle;
      dataArr[i++] = row.material && row.material.code;
      dataArr[i++] = row.material && row.material.name;
      dataArr[i++] = row.material && row.material.ingredient;
      dataArr[i++] = row.quantity - row.schedulingQuantity;
      dataArr[i++] = row.startTime && this.dayjs(row.startTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[i++] = row.endTime && this.dayjs(row.endTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[i++] = row.org && row.org.code;
      dataArr[i++] = mainPlanNo;
      dataArr[i++] = 1;
      dataArr[i++] = '否';
      dataArr[i++] = row.regularCapacity;
      dataArr[i++] = row.remark;
      return dataArr;
    },
    importData() {
      const data = this.deepClone([...this.tableData]);
      if (data.length <= 0) {
        this.$message.warning(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.saveLoading = true;
      if (this.listLength == null || this.listLength.length == 0) {
        return this.http
          .post('/custom/senmusi/production/plan/batchImportSchedulingDistribution?onlyValidate=false', data)
          .then(res => {
            this.$message.success(this.$t(res.msg));
            this.show = false;
            // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
            this.utils.event_hub.$emit('ORDER_MANAGEMENT_REFRESH');
          })
          .catch(error => {
            this.$message.error(error);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
        this.saveLoading = false;
      }
    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {
      const files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i]);
      }

      this.uploadLoading = true;
      document.getElementById('matterFileInput').value = '';
      setTimeout(() => {
        let data = [...this.tableData];
        this.http
          .post('/custom/senmusi/production/plan/batchImportSchedulingDistribution?onlyValidate=true', data)
          .then(response => {
            this.listLength = response.data.validateItems;
            if (response.data.validateItems && response.data.validateItems.length > 0) {
              const list = response.data.validateItems;
              for (let i = 0; i < list.length; i++) {
                this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','));
              }
            }
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      }, 800);
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false;
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false;
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false;
      }
      this.readerData(rawFile);
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = e => {
        const name = rawFile.name;
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const header = this.getHeaderRow(worksheet);
        const results = XLSX.utils.sheet_to_json(worksheet);
        this.generateData({
          header,
          results,
          name
        });
      };
      reader.readAsArrayBuffer(rawFile);
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell =
          sheet[
          XLSX.utils.encode_cell({
            c: C,
            r: R
          })
          ];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({ header, results, name }) {
      const data = [];
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          };
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']] !== undefined) {
              this.$set(item, this.tableColumn[j]['prop'], results[i][this.tableColumn[j]['label']]);
            }
          }
          data.push(item);
        }
      }
      this.tableData = this.tableData.concat(data);
      for (let i = 0; i < this.tableData.length; i++) {
        this.$set(this.tableData[i], 'rid', i + 1);
      }
      this.excel.push(name);
      this.countTableHeight();
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter(item => {
        return item !== name;
      });
      this.tableData = this.tableData.filter(item => {
        return item.excel !== name;
      });
      console.log('excel:', this.excel);
      console.log('tableData:', this.tableData);
      console.log('tableColumn', this.tableColumn);
    },
    countTableHeight() {
      this.tableHeight = 0;
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10;
        } else {
          this.tableHeight = 110;
        }
      });
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',

        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
